import { isSiteDomain } from "./domainManager";

export var baseUrl = "https://api.gitymarket.ir/";
export var mapKey = "web.dxylUsH93BpB7201il2HblPZeFPtsr9zh3qfwMnv";
export var token = "aec86f8c-0b4b-4a6b-8549-c961e811b52b";
export var dynamicVersion = 1000;
export var sentryEnvironment = "production";
export var isDevelopServer = false;

if (
  window.location.host.startsWith("localhost") ||
  window.location.host.startsWith("192.168") ||
  window.location.host.startsWith("dev.gity")
) {
  baseUrl = "https://dev-api.gitymarket.ir/";
  mapKey = "web.mEGQ36f4G97wWtGxOWqPVkRRvz4GK5dbqYdRBQgj";
  token = "673aba90-8a03-4d00-ba13-5eaae1580dc6";
  sentryEnvironment = "develop";
  isDevelopServer = true;
} else if (isSiteDomain) {
  if (window.location.host.includes("dev.")) {
    baseUrl = `https://${window.location.host.replace("dev.", "api-dev.")}/`;
    token = "673aba90-8a03-4d00-ba13-5eaae1580dc6";
  } else {
    baseUrl = `https://api.${window.location.host}/`;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  baseUrl,
  mapKey,
  token,
  sentryEnvironment,
  isDevelopServer,
};
